export default "__VITE_ASSET__C8D3vBTv__"